module.exports = __webpack_public_path__ + "static/media/testimonial_4.7e2ef85d.jpg";